/**
 * @name virus-off
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAuMDEgMTBoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xMiAxNC45OTFoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xMiAyMnYtMyIgLz4KICA8cGF0aCBkPSJNMTIgMnYzIiAvPgogIDxwYXRoIGQ9Ik0xMyAyMmgtMiIgLz4KICA8cGF0aCBkPSJNMTMgMmgtMiIgLz4KICA8cGF0aCBkPSJtMTYuNSAxOS43OTQtMS0xLjczMyIgLz4KICA8cGF0aCBkPSJtMTYuNSA0LjIwNS0xIDEuNzMyIiAvPgogIDxwYXRoIGQ9Ik0xOC44OTEgMTMuMjM1YTcgNyAwIDAwLTguMTI2LTguMTI2IiAvPgogIDxwYXRoIGQ9Im0xOS43OTQgNy41LTEuNzMyIDEiIC8+CiAgPHBhdGggZD0iTTIgMTJoMyIgLz4KICA8cGF0aCBkPSJNMiAxM3YtMiIgLz4KICA8cGF0aCBkPSJtMiAyIDIwIDIwIiAvPgogIDxwYXRoIGQ9Ik0yMiAxMmgtMyIgLz4KICA8cGF0aCBkPSJNMjIgMTN2LTIiIC8+CiAgPHBhdGggZD0ibTQuMjA2IDE2LjUgMS43MzItMSIgLz4KICA8cGF0aCBkPSJtNC4yMDYgNy41IDEuNzMyIDEiIC8+CiAgPHBhdGggZD0iTTcuMDUgNy4wNWE3IDcgMCAwMDkuOSA5LjkiIC8+CiAgPHBhdGggZD0ibTcuNSAxOS43OTQgMS0xLjczMyIgLz4KICA8cGF0aCBkPSJNOSAxMmguMDEiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/virus-off
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const VirusOff: string = `
<svg
  class="lucide lucide-virus-off"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M10.01 10h.01" />
  <path d="M12 14.991h.01" />
  <path d="M12 22v-3" />
  <path d="M12 2v3" />
  <path d="M13 22h-2" />
  <path d="M13 2h-2" />
  <path d="m16.5 19.794-1-1.733" />
  <path d="m16.5 4.205-1 1.732" />
  <path d="M18.891 13.235a7 7 0 00-8.126-8.126" />
  <path d="m19.794 7.5-1.732 1" />
  <path d="M2 12h3" />
  <path d="M2 13v-2" />
  <path d="m2 2 20 20" />
  <path d="M22 12h-3" />
  <path d="M22 13v-2" />
  <path d="m4.206 16.5 1.732-1" />
  <path d="m4.206 7.5 1.732 1" />
  <path d="M7.05 7.05a7 7 0 009.9 9.9" />
  <path d="m7.5 19.794 1-1.733" />
  <path d="M9 12h.01" />
</svg>
`;

export default VirusOff;
